module.exports = "<div class=\" timerWrap\">\n  <p class=\" bigTime\">\n    <span [style.color]=\"color\">{{fullTime.m}}</span>\n  </p>\n  <span class=\"totalTime\">{{totalTimeView}}</span>\n  <div class=\"fullProgressbar\"></div>\n  <div class=\"currentProgressBar\" [ngStyle]=\"{'background': bgColor, 'width': width + '%'}\"></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/orders-list-timer/orders-list-timer.component.html
// module id = ./src/app/dashboard/orders-list-timer/orders-list-timer.component.html
// module chunks = main